"use strict";require("./_typed-array")("Int8",1,function(r){return function(t,n,e){return r(this,t,n,e)}});